// extracted by mini-css-extract-plugin
var _1 = "BirdviewBarsChart-modulebars__rNw4U";
var _2 = "BirdviewBarsChart-modulelist__DnKmj";
var _3 = "BirdviewBarsChart-modulenote__cgJEm ChartItemLabel-modulelabel__hMN1y";
export { _1 as "bars", _2 as "list", _3 as "note" }
